/**
 * Alternative header component that doesn't render breadcrumbs or a heading
 * It also renders the DraftsToggle next to the MoreMenu
 */
import React from 'react';
import { type OwnProps as MoreMenuProps } from '../more-menu/types';
import {
	DraftsToggle,
	TreeStates,
	useConfluencePageTree,
} from '@atlassiansox/confluence-table-tree';
import { Inline, xcss } from '@atlaskit/primitives';
import { useProjectPages } from '../../containers/project-pages';
import { useRouter } from '../../containers/view-router-context';
import { Routes } from '../../containers/view-router-context/types';

export type CompactHeaderProps = {
	shouldShowMeatballMenu: boolean;
	MoreMenu: React.ComponentType<MoreMenuProps>;
};

export const CompactHeader = ({ shouldShowMeatballMenu, MoreMenu }: CompactHeaderProps) => {
	const { activeRoute } = useRouter();
	const { locale } = useProjectPages();
	const { treeState } = useConfluencePageTree();

	const isTreeLoaded = treeState && treeState !== TreeStates.Loading;
	// only show the drafts toggle if the PageTree would be loaded (see ActivePage component)
	const shouldShowDraftsToggle =
		isTreeLoaded &&
		(!activeRoute ||
			![
				Routes.TemplatePreview,
				Routes.ConfluenceActivating,
				Routes.ConfluenceActivatingOnDemand,
				Routes.ConnectSpace,
				Routes.ServerError,
				Routes.ServerErrorAccess,
				Routes.SpaceOrPageNotFound,
			].includes(activeRoute));

	return (
		<Inline alignInline="end" space="space.100" xcss={compactHeaderStyles}>
			{shouldShowMeatballMenu && <MoreMenu />}
			{shouldShowDraftsToggle && <DraftsToggle locale={locale} />}
		</Inline>
	);
};

const compactHeaderStyles = xcss({
	marginBottom: 'space.200',
});
